import { FloorFloorplan, FloorHeader, LabelType, LayoutHeader } from '@dms/component'
import { Suspense } from 'react'
import { StyleSheet, useWindowDimensions, View } from 'react-native'
import { useNumberParams, useStringParams } from 'zens-router'
import { Spacing } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.S,
    padding: Spacing.S,
    flex: 1,
  },
})

const FloorViewScreen = () => {
  const [{ companyId, locationId, buildingId, floorId }] = useNumberParams()
  const [{ labels }, setParams] = useStringParams<LabelType | undefined>()
  const { height } = useWindowDimensions()
  const contentStyle = { height: height - 130 - 2 * Spacing.M }

  function updateLabels(labels?: LabelType) {
    setParams({ labels })
  }

  return (
    <View style={styles.container}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <FloorHeader
          companyId={companyId}
          locationId={locationId}
          buildingId={buildingId}
          floorId={floorId}
          labels={labels}
          onChangeLabels={updateLabels}
        />
      </Suspense>
      <View style={styles.content}>
        <Suspense fallback={<FloorFloorplan.Skeleton style={contentStyle} />}>
          <FloorFloorplan companyId={companyId} floorId={floorId} style={contentStyle} labels={labels} />
        </Suspense>
      </View>
    </View>
  )
}

export default FloorViewScreen
